export default {
  member: '7209ebc7-6536-469a-8a52-dac38de3f941',
  cdp: '52ac6eba-064d-4bcc-9e46-d3f42dfeb7fa',
  campaign: 'fe215caa-efeb-4646-836a-92cd3904f3d7',
  settings: 'f3f9eb1c-5c85-4687-a6ac-3c76045e5b21'
}
